import ScoringChart from './ScoringChart';

export default ScoringChart;
